(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oyx-gift-threshold"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oyx-gift-threshold')) {
    customElements.define('oyx-gift-threshold', class extends HTMLElement {
      connectedCallback() {
        const currency = this.dataset.currency || window.Shopify?.currency?.active || 'EUR';
        const rate = currency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate);
        if (!Number.isFinite(rate) || rate <= 0) return;
        const converted = Number(this.dataset.baseAmount) * rate;
        const amount = currency === 'EUR' ? converted : Math.ceil(converted / 5) * 5;
        this.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency', currency, maximumFractionDigits: 0, minimumFractionDigits: 0
        }).format(amount);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
